
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogEditGoogle as ObiLogEditGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-log-edit-google.js';
 
 
 

 
 export const ObiLogEditGoogle = createComponent({
   react: React,
   tagName: 'obi-log-edit-google',
   elementClass: ObiLogEditGoogleElement,
   events: {
     
   }
  });
 
 